import { render, staticRenderFns } from "./patient-details-viewer.vue?vue&type=template&id=56f5d4e4&scoped=true"
import script from "./patient-details-viewer.vue?vue&type=script&lang=js"
export * from "./patient-details-viewer.vue?vue&type=script&lang=js"
import style0 from "./patient-details-viewer.vue?vue&type=style&index=0&id=56f5d4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5d4e4",
  null
  
)

export default component.exports